
import { useState, useEffect } from "react";

/**
 * Un hook personnalisé pour détecter si une media query correspond à l'écran actuel
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Vérification initiale
    const media = window.matchMedia(query);
    setMatches(media.matches);

    // Fonction de callback pour les changements de media query
    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Ajouter le listener pour les changements de taille
    media.addEventListener("change", listener);
    
    // Nettoyage
    return () => {
      media.removeEventListener("change", listener);
    };
  }, [query]);

  return matches;
}
